// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__Vp1Wk","spinner":"loader_spinner__AvfnA"};